import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=6f7baa35&scoped=true"
import script from "./Sales.vue?vue&type=script&lang=js"
export * from "./Sales.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/inbox.css?vue&type=style&index=0&id=6f7baa35&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7baa35",
  null
  
)

export default component.exports